import axios from 'axios';

// Every request must ride the auth session cookie.
axios.defaults.withCredentials = true;

let redirecting = false;

// setupHttp registers a global response interceptor on the shared axios
// instance. Because every component imports that same singleton, this single
// registration covers all API calls in the app.
//
// On 401 (session missing/expired) the user is sent back to the login screen.
// 403 (authenticated but lacking permission) is intentionally left for the
// calling component to handle so a logged-in user is not bounced to login.
export default function setupHttp(router) {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        localStorage.removeItem('user');

        const onLoginScreen = router.currentRoute.name === 'login';
        if (!onLoginScreen && !redirecting) {
          redirecting = true;
          router.replace({ name: 'login' }).finally(() => {
            redirecting = false;
          });
        }
      }

      return Promise.reject(error);
    },
  );
}
